import React, { useState } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import VideoThumbnail from 'react-video-thumbnail';
import { useTranslation } from 'react-i18next';

const MessageBubble = ({
  message,
  messageType,
  userId,
  userProfileId,
  formatDate,
  openViewModel,
  fileName,
  isRead,
  createdAt,
  nowDate,
}) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);

  const handleImageError = (e) => {
    e.target.style.display = 'none';
    if (e.target.nextElementSibling) {
      e.target.nextElementSibling.style.display = 'block';
    }
  };

  // Sender message bubble
  if (userId === userProfileId) {
    return (
      <Box
        sx={{
          height: 'auto',
          minHeight: '70px',
          width: '265px',
          marginLeft: 'auto',
          position: 'relative',
          marginBottom: '8px',
        }}
      >
        <Grid container>
          <Grid item className="chat_send" textAlign={'left'}>
            {messageType === 'message' ? (
              <Typography textAlign={'end'}>{message}</Typography>
            ) : (
              <Box
                display={'flex'}
                alignItems={'center'}
                style={{
                  maxWidth: '100%',
                  padding: '10px',
                  border: '1px solid #ccc',
                  borderRadius: '8px',
                  backgroundColor: '#f9f9f9',
                }}
              >
                {messageType === 'image' ? (
                  <Box
                    display="flex"
                    alignItems="center"
                    flex="1"
                    position="relative"
                    sx={{ cursor: 'pointer' }}
                    onClick={() => {
                      openViewModel(message, 'image', fileName);
                    }}
                  >
                    <img
                      src={message}
                      alt={fileName}
                      style={{
                        width: '100%',
                        height: 'auto',
                        maxHeight: '150px',
                        display: 'block',
                        borderRadius: '8px',
                        objectFit: 'contain',
                        maxWidth: '200px',
                        padding: '10px',
                      }}
                      onError={handleImageError}
                    />
                    <Typography
                      style={{
                        display: 'none',
                        textAlign: 'center',
                        width: '100%',
                        color: '#888',
                      }}
                    >
                      {t('chat.notAvailable')}
                    </Typography>
                  </Box>
                ) : messageType === 'video' ? (
                  <Box
                    display="flex"
                    alignItems="center"
                    margin={'10px 0px 0px 0px'}
                    style={{
                      width: '100%',
                      maxWidth: '100%',
                      padding: '10px',
                      border: '1px solid #ccc',
                      borderRadius: '8px',
                      backgroundColor: '#f9f9f9',
                    }}
                  >
                    <Typography
                      style={{
                        width: '100%',
                        cursor: 'pointer',
                        color: '#007bff',
                        textDecoration: 'underline',
                      }}
                      onClick={() => {
                        openViewModel(message, 'video', fileName);
                      }}
                    >
                      <VideoThumbnail
                        videoUrl={message}
                        thumbnailHandler={(thumbnail) => {
                          setLoading(false);
                        }}
                      />
                      {!loading && (
                        <div
                          style={{
                            position: 'absolute',
                            top: '50%',
                            left: '45%',
                            transform: 'translate(-50%, -50%)',
                            cursor: 'pointer',
                            width: '48px',
                            height: '48px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: 'rgba(0, 0, 0, 0.6)',
                            borderRadius: '50%',
                          }}
                          onClick={() => openViewModel(message, 'video', fileName)}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="white"
                            width="24"
                            height="24"
                          >
                            <path d="M8 5v14l11-7z" />
                          </svg>
                        </div>
                      )}
                    </Typography>
                  </Box>
                ) : (
                  <Typography
                    textAlign={'end'}
                    color={'#000'}
                    onClick={() => {
                      openViewModel(message, 'file', fileName);
                    }}
                    sx={{
                      cursor: 'pointer',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {fileName}
                  </Typography>
                )}
              </Box>
            )}
            <Box height={'16px'} textAlign={'end'}>
              {isRead ? (
                <span>
                  <DoneAllIcon sx={{ color: '#000' }} fontSize="16px" />
                </span>
              ) : (
                <span>
                  <CheckIcon sx={{ color: '#000' }} fontSize="16px" />
                </span>
              )}
              <Typography
                variant="caption"
                sx={{
                  textAlign: 'left',
                  color: '#000',
                  marginLeft: '10px',
                }}
              >
                {createdAt ? formatDate(createdAt) : nowDate}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    );
  }

  // Receiver message bubble
  return (
    <Box
      sx={{
        wordBreak: 'break-word',
        lineBreak: 'anywhere',
        height: 'auto',
        minHeight: '70px',
        width: '241px',
        background: '#5d6c7b',
        borderRadius: '0px 10px 10px 10px',
        overflow: 'hidden',
        padding: '10px',
        marginBottom: '8px',
      }}
      position={'relative'}
    >
      {messageType === 'message' ? (
        <Typography className="chat_receiver" textAlign={'left'}>
          {message}
        </Typography>
      ) : (
        <Box
          display={'flex'}
          justifyContent={'space-between'}
          alignItems={'center'}
          width={'100%'}
          borderRadius={'8px'}
          style={{ backgroundColor: '#f9f9f9' }}
          padding={'10px'}
        >
          {messageType === 'image' ? (
            <>
              <img
                src={message}
                alt={fileName}
                style={{
                  width: '100%',
                  height: 'auto',
                  maxHeight: '150px',
                  display: 'block',
                  borderRadius: '8px',
                  objectFit: 'contain',
                  maxWidth: '200px',
                  margin: '0 auto',
                  padding: '10px',
                }}
                onClick={() => {
                  openViewModel(message, 'image', fileName);
                }}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.style.display = 'none';
                  e.target.nextElementSibling.style.display = 'block';
                }}
              />
              <Typography
                style={{
                  display: 'none',
                  textAlign: 'center',
                  width: '100%',
                  color: '#888',
                }}
              >
                {t('chat.notAvailable')}
              </Typography>
            </>
          ) : messageType === 'video' ? (
            <Box
              display="flex"
              alignItems="center"
              margin={'10px 0px 0px 0px'}
              style={{
                width: '100%',
                maxWidth: '100%',
                padding: '10px',
                border: '1px solid #ccc',
                borderRadius: '8px',
                backgroundColor: '#f9f9f9',
              }}
            >
              <Typography
                style={{
                  width: '100%',
                  cursor: 'pointer',
                  color: '#007bff',
                  textDecoration: 'underline',
                }}
                onClick={() => {
                  openViewModel(message, 'video', fileName);
                }}
              >
                <VideoThumbnail
                  videoUrl={message}
                  thumbnailHandler={(thumbnail) => {
                    setLoading(false);
                  }}
                />
                {!loading && (
                  <div
                    style={{
                      position: 'absolute',
                      top: '50%',
                      left: '50%',
                      transform: 'translate(-50%, -50%)',
                      cursor: 'pointer',
                      width: '48px',
                      height: '48px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: 'rgba(0, 0, 0, 0.6)',
                      borderRadius: '50%',
                    }}
                    onClick={() => openViewModel(message, 'video', fileName)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="white"
                      width="24"
                      height="24"
                    >
                      <path d="M8 5v14l11-7z" />
                    </svg>
                  </div>
                )}
              </Typography>
            </Box>
          ) : (
            <Typography
              textAlign={'end'}
              color={'#000'}
              onClick={() => {
                openViewModel(message, 'file', fileName);
              }}
              sx={{
                cursor: 'pointer',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {fileName}
            </Typography>
          )}
        </Box>
      )}
      <Typography
        variant="caption"
        sx={{ textAlign: 'left', marginLeft: '10px' }}
      >
        {formatDate(createdAt)}
      </Typography>
    </Box>
  );
};

export default MessageBubble;
